import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import PendingOrder from '../PendingOrder/PendingOrder';
import queryString from "query-string";
import { setScartId } from '../../CustomizeOrder/containers/actions';
import { postUIEventLog } from '../containers/action';
import { connect } from 'react-redux';
import * as SiteAnalytics from '../../../sitecatalyst';
import { isNightTimeWindow } from './../../../utils/common';

const RetrievePendingOrder = (props) => {

    const [scartid, setScartid] = useState("");
    const [endInteraction, setEndInteraction] = useState(false);

    useEffect(() => {
        setEndInteraction(true);
    }, [])
    useEffect(() => {
        window.scrollTo(0, 0);
        const values = queryString.parse(props.location.search);
		const scartId = values && values.scartid;
        setScartid(scartId);
        if(endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            setEndInteraction(false);
        }
    });
    
    useEffect(() => {
        props.postUIEventLog({ eventType: 'log', eventName: "PENDINGORDER_PageLoad", sectionName: "Page" });
        SiteAnalytics.trackPageInfo('RetrievePendingOrder');
    }, [])

    const continuePendingOrder = (value) => { 
        if(!value) {
            props.setScartId(scartid);
        }
        value ? props.history.push("/pending-order") : props.history.push({ pathname: `/customize-order`, search: props.history.location.search });
        SiteAnalytics.trackOrderStatus(value);
        if (window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction(`Pending Order ${value ? 'Yes' : 'No'} Button Click`, { data: window.LQRequestBody });
        }
        if (!value) {
            const addressID = props?.addressQualificationDetails?.AddressIdPresent;
            const isNightTimeWindowVar = isNightTimeWindow();
            if (  !isNightTimeWindowVar) {

                SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
        }
        props.postUIEventLog({ eventType: 'log', eventName: "Continue Pending Order Button Click", sectionName: "LQ", log: "" });
    }

    const handleBackClickEvent = () => {
        props.history.go(-1);
        props.postUIEventLog({ eventType: 'log', eventName: "Pending Order Back Button Click", sectionName: "LQ", log: "" });
    }

    return (
        <div className="pending-order-page" style={{marginBottom : '7rem'}}>
            <PendingOrder  PendingOrderCallback={continuePendingOrder}
                isPendingOrderPage={true}
                            handleBackClickEvent={handleBackClickEvent} {...props} />
        </div>
    );
};


const mapStateToProps = (state) => {
    return {
        addressData: state.AddressValidationPage,
        addressQualificationDetails: state.AddressValidationPage.addressQualificationDetails,
		optixAddressQualificationDetails: state.AddressValidationPage.optixAddressQualificationDetails,
    };
};

const mapDispatchToProps = (dispatch) => ({
    postUIEventLog: (data) => { dispatch(postUIEventLog(data)) },
    setScartId: (data) => { dispatch(setScartId(data)) }
});


export default connect(mapStateToProps, mapDispatchToProps)(RetrievePendingOrder);